import { adminHttpClient } from "../../../commons/adminHttpClinet";
import { SubscriptionPlans } from "../../../models/dashboard/subscriptions/subscriptions";

const getSubscriptionPlans = (): Promise<Array<SubscriptionPlans>> => {
    console.log("get subscription plans:")
    return adminHttpClient.get(`/api/Admin/AdminSubscriptions/get-subscription-plans`)
}

export default getSubscriptionPlans;